import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdQueuesRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-queues',
	path: '/projects/:projectKey/queues/:custom(custom)?/:id?',
};
